/* eslint-disable */
export default {
  _pt_sansregular: 'pt_sansregular',
  _bebasregular: 'bebasregular',
  _droid_sansbold: 'droid_sansbold',
  _neuropolregular: 'neuropolregular',
  _ostrich_sansheavy: 'ostrich_sansheavy',
}